import { FormattedMessage } from 'react-intl';

export interface CartTitleProps {
  participantCount: number;
  countClassName?: string;
}

const CartTitle = ({ countClassName, participantCount }: CartTitleProps) => (
  <>
    <FormattedMessage defaultMessage='My cart' id='cartTitle' />
    {participantCount > 0 && (
      <span className={countClassName}>
        <FormattedMessage
          defaultMessage='· {count, plural, one {# participant} other {# participants}}'
          id='cartTitleParticipantCount'
          values={{ count: participantCount }}
        />
      </span>
    )}
  </>
);

export default CartTitle;
